import AxiosClient from '../AxiosClient';
import { SERVICE, ENV } from "../../Config/constants";

const service = AxiosClient.getInstance();

//Get Profile Details
export const getProfileDetailsApi = async () => {
  const url = `${ENV}${SERVICE.PROFILE.GET_PROFILE_DETAILS}`;
  return service.GetApiRequest(url);
};

//Get Language Details
export const getLanguageDetailsApi = async () => {
  const url = `${ENV}${SERVICE.PROFILE.GET_LANGUAGE_DETAILS}`;
  return service.GetApiRequest(url);
}
export const getJobDetailsApi = async (language) => {
  const url = `${ENV}${SERVICE.PROFILE.GET_JOB_DEPARTMENT_DETAILS}?language=${language}&type=jobTitle`;
  return service.GetApiRequest(url);
}
export const getDepartmentDetailsApi = async (language) => {
  const url = `${ENV}${SERVICE.PROFILE.GET_JOB_DEPARTMENT_DETAILS}?language=${language}&type=department`;
  return service.GetApiRequest(url);
}

//Update Profile Details
export const updateProfileDetailsApi = async (req) => {
  const URL = `${ENV}${SERVICE.PROFILE.UPDATE_PROFILE_DETAILS}`;
  return service.PutApiRequest(URL, req);
};
